// extracted by mini-css-extract-plugin
export default {"root":"joined-project_root__YHXBI","controlPrev":"joined-project_controlPrev__ome1W","controlNext":"joined-project_controlNext__4lZw+"};